module.exports = __webpack_public_path__ + "static/media/deeksha.86007d7e.png";